<h2 mat-dialog-title>

  <span *ngIf="selectedFlat.name">{{'COMMON.EDIT' | translate}} - {{selectedFlat.name}}</span>
  <span *ngIf="!selectedFlat.name">{{'COMMON.CREATE_NEW' | translate}}</span>

</h2>
<mat-dialog-content [formGroup]="form">


  <mat-tab-group (selectedTabChange)="onSelectedTabChanged($event)">
    <mat-tab class="modal-tab" label="{{'FLAT.TAB.0' | translate}}"></mat-tab>
    <mat-tab class="modal-tab" label="{{'FLAT.TAB.1' | translate}}"></mat-tab>
    <mat-tab class="modal-tab" label="{{'FLAT.TAB.2' | translate}}"></mat-tab>
    <mat-tab class="modal-tab" label="{{'FLAT.TAB.3' | translate}}"></mat-tab>
    <mat-tab class="modal-tab" label="{{'FLAT.TAB.4' | translate}}"></mat-tab>
    <mat-tab class="modal-tab" label="{{'FLAT.TAB.5' | translate}}"></mat-tab>
    <mat-tab class="modal-tab" label="{{'FLAT.TAB.6' | translate}}"></mat-tab>
  </mat-tab-group>

  <form [formGroup]="form">
    <div class="tab-content-container">

      <div [hidden]="activeTabIndex !== 6" class="uploader-container">
        <img *ngIf="selectedFlat && selectedFlat.buildingInImageUrl" [src]="selectedFlat.buildingInImageUrl">
        <mat-icon class="dark" *ngIf="selectedFlat && selectedFlat.buildingInImageUrl"
                  (click)="deleteLayoutImage('buildingIn')">delete
        </mat-icon>

        <app-custom-drop-zone
          *ngIf="!selectedFlat || !selectedFlat.buildingInImageUrl"
          (uploadFinished)="onBuildingInImageUploadFinished($event)"
          [uploadPath]="'flat'"
          [height]="'250px'">
        </app-custom-drop-zone>
      </div>

      <div [hidden]="activeTabIndex !== 5" class="uploader-container">
        <img *ngIf="selectedFlat && selectedFlat.layoutImageUrl" [src]="selectedFlat.layoutImageUrl">
        <mat-icon class="dark" *ngIf="selectedFlat && selectedFlat.layoutImageUrl"
                  (click)="deleteLayoutImage('layout')">delete
        </mat-icon>

        <app-custom-drop-zone
          *ngIf="!selectedFlat || !selectedFlat.layoutImageUrl"
          (uploadFinished)="onLayoutImageUploadFinished($event)"
          [uploadPath]="'flat'"
          [height]="'250px'">
        </app-custom-drop-zone>
      </div>

      <div [hidden]="activeTabIndex !== 4" class="uploader-container">
        <img *ngIf="selectedFlat && selectedFlat.salesImageUrl" [src]="selectedFlat.salesImageUrl">
        <mat-icon class="dark" *ngIf="selectedFlat && selectedFlat.salesImageUrl" (click)="deleteLayoutImage('sales')">
          delete
        </mat-icon>

        <app-custom-drop-zone
          *ngIf="!selectedFlat || !selectedFlat.salesImageUrl"
          (uploadFinished)="onSalesImageUploadFinished($event)"
          [uploadPath]="'flat'"
          [height]="'250px'">
        </app-custom-drop-zone>
      </div>

      <div *ngIf="activeTabIndex === 3">

        <div class="row">
          <div class="col-12">
            <app-flat-frontage-position-selector
              [selectedFlat]="selectedFlat"
              (positionSelected)="onFrontagePositionSelected($event)"></app-flat-frontage-position-selector>
          </div>
        </div>

      </div>

      <div *ngIf="activeTabIndex === 2">

        <div class="row">
          <div class="col-12">
            <app-flat-map-section (pointSelected)="onPointSelected($event)" [selectorMode]="true"
                                  [selectedFlat]="selectedFlat"></app-flat-map-section>
          </div>
        </div>

      </div>

      <div [hidden]="activeTabIndex !== 1">

        <div class="row">
          <div class="col-12">
            <app-flat-area-editor [parentForm]="form"></app-flat-area-editor>
          </div>
        </div>

      </div>

      <div [hidden]="activeTabIndex !== 0">
        <div class="row">
          <div class="col-4">

            <mat-form-field>

              <input matInput
                     type="text"
                     placeholder="{{'FLAT.NAME' | translate}}"
                     formControlName="name">

            </mat-form-field>

          </div>

          <div class="col-4">

            <mat-form-field>

              <input matInput
                     type="text"
                     placeholder="{{'FLAT.PRICE' | translate}}"
                     formControlName="price">

            </mat-form-field>

          </div>

          <div class="col-4">

            <mat-form-field>

              <input matInput
                     type="number"
                     placeholder="{{'FLAT.SIZE' | translate}}"
                     formControlName="size">

            </mat-form-field>

          </div>

          <div class="col-4">
            <mat-checkbox formControlName="isOffice">{{'FLAT.IS_OFFICE' | translate}}</mat-checkbox>
          </div>

          <div class="col-4">

            <mat-form-field [class.invisible]="form.value['isOffice'] === true">

              <input matInput
                     type="text"
                     placeholder="{{'FLAT.NUMBEROFROOMS' | translate}}"
                     formControlName="numberOfRooms">

            </mat-form-field>

          </div>


          <div class="col-4">

            <mat-form-field [class.invisible]="form.value['isOffice'] === true">

              <input matInput
                     type="number"
                     placeholder="{{'FLAT.GARDEN' | translate}}"
                     formControlName="garden">

            </mat-form-field>

          </div>

          <div class="col-4">

            <mat-form-field>

              <input matInput
                     type="number"
                     readonly
                     class="disabled"
                     disabled
                     placeholder="{{'FLAT.LEVEL' | translate}}"
                     formControlName="level">

            </mat-form-field>

          </div>
          <div class="col-4">

            <mat-form-field>

              <input matInput
                     type="number"
                     class="disabled"
                     readonly
                     disabled
                     placeholder="{{'FLAT.LATITUDE' | translate}}"
                     formControlName="latitude">

            </mat-form-field>

          </div>
          <div class="col-4">

            <mat-form-field>

              <input matInput
                     type="number"
                     readonly
                     class="disabled"
                     disabled
                     placeholder="{{'FLAT.LONGITUDE' | translate}}"
                     formControlName="longitude">

            </mat-form-field>

          </div>


          <div class="col-4">

            <mat-form-field>

              <input matInput
                     type="text"
                     readonly
                     disabled
                     class="disabled"
                     placeholder="{{'FLAT.SIDE' | translate}}"
                     formControlName="side">

            </mat-form-field>

          </div>
          <div class="col-4">

            <mat-form-field>

              <input matInput
                     type="number"
                     readonly
                     disabled
                     class="disabled"
                     placeholder="{{'FLAT.COORDINATEX' | translate}}"
                     formControlName="coordinateX">

            </mat-form-field>

          </div>
          <div class="col-4">

            <mat-form-field>

              <input matInput
                     type="number"
                     readonly
                     disabled
                     class="disabled"
                     placeholder="{{'FLAT.COORDINATEY' | translate}}"
                     formControlName="coordinateY">

            </mat-form-field>

          </div>


          <div class="col-6">
            <mat-checkbox formControlName="reserved">{{'FLAT.RESERVED' | translate}}</mat-checkbox>
          </div>

          <div class="col-6">
            <mat-checkbox formControlName="soldOut">{{'FLAT.SOLD_OUT' | translate}}</mat-checkbox>
          </div>

        </div>
      </div>

    </div>
  </form>

</mat-dialog-content>

<app-modal-footer [disabled]="!form.valid" (submit)="save()" (close)="close()"></app-modal-footer>
